import styled from 'styled-components';

interface IPropsInputDate {
  error: boolean;
  dateValue: Date | undefined;
}

export const Container = styled.div<IPropsInputDate>`
  width: 100%;
  min-width: 160px !important;

  .react-date-picker {
    width: 100%;

    .react-date-picker__wrapper {
      padding: 0 16px;
      height: 48px;

      border: 1px solid
        ${({ theme, error }) =>
          !error ? theme.colors.gray[400] : theme.colors.attention};
      border-radius: 8px;

      background-color: #fff;

      font-weight: 400;
      font-size: 12px;

      width: 100%;

      .react-date-picker__inputGroup {
        display: flex;
        align-items: center;
      }

      span,
      .react-date-picker__inputGroup__input {
        color: ${({ theme }) => theme.colors.gray[500]};
        outline: none;
      }

      .react-date-picker__inputGroup__input:invalid {
        background-color: transparent;
      }
    }

    .react-calendar__tile--active {
      border-radius: 3px;
      background: ${({ theme }) => theme.colors.orange.primary};
    }

    .react-calendar__tile--now {
      background: ${({ theme }) => theme.colors.blue.medium};
      border-radius: 3px;
      color: ${({ theme }) => theme.colors.white};
    }

    .react-calendar__tile:disabled,
    .react-calendar__navigation button:disabled {
      background-color: #fff;
      color: #d9d9d9;
    }
  }

  .react-date-picker__inputGroup__divider,
  .react-date-picker__inputGroup__month,
  .react-date-picker__inputGroup__year {
    display: ${({ dateValue }) => (!dateValue ? 'none' : null)};
  }
`;

export const Error = styled.div`
  position: absolute;
  margin: 0;
  line-height: 100%;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.attention} !important;
  bottom: -16px;
  height: fit-content;
  left: 16px;
  height: fit-content;
`;
